import moment from "moment"

  export function sendSuccessNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_UPDATED', notice);
  }
  
  export function sendErrorNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_FAILED', notice);
  }

  export function refreshResource () {
    window.getApp.$emit('REQUEST_REFRESH_DATA');
  }

  export function loadingData (value) {
    window.getApp.$emit('APP_LOADING', value);
  }

  export function buildBreadcrumb(routeName, routePath, pId, title, menu, paths) {
    let breadcrumbs = [];
    menu.forEach(item => {
      if (item.name === routeName) {
        breadcrumbs.push({
          text: item.title,
          link: false,
          href: ""
        });
      } else if (item.items) {
        breadcrumbs = _.concat(breadcrumbs, buildBreadcrumb(routeName, routePath, pId, title, item.items, paths))
      } else if (item.children) {
        let child = item.children.find(i => {
          return i.component === routeName;
        });
        if (child) {
          let path = _.find(paths, { name: item.name });
          breadcrumbs.push({
            text: item.title,
            disabled: false,
            href: path ? path.path : ""
          });
          breadcrumbs.push({
            text: title || `${child.title} (#${pId})`,
            link: false,
            href: ""
          });
        }
      }
    });
    return breadcrumbs;
  }

  export function getCurrentTime() {
    var d = new Date();
    d.setTime( d.getTime());
    return moment(d);
  }

  export function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}

export function convertToSlug(str) {
  str = str.replace(/^\s+|\s+$/g, "");
  str = str.toLowerCase();

  var from = "àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ·/_,:;";
  var to = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeiiiiiooooooooooooooooouuuuuuuuuuuyyyyyd------";
  for (let i=0; i < from.length; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-") .replace(/-+/g, "-");

  return str;
}